module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.$route.name) + "\n")])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box user-tb"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title pull-right"
  }, [_c('button', {
    staticClass: "btn primary-btn-my clear-new-modal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.newModal = true
      }
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.newModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.newModal = $event
      },
      "update:md-active": function($event) {
        _vm.newModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Edit Organisation\n        "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.newModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "from-padding modal-width-100"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClassNewForm('email')
  }, [_c('md-chips', {
    staticClass: "md-primary",
    attrs: {
      "md-placeholder": "Enter email Addresses",
      "md-auto-insert": true
    },
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  }, [_c('label', [_vm._v("Email Addresses")]), _vm._v(" "), _c('div', {
    staticClass: "md-helper-text"
  }, [_vm._v("Add a email addresses and press enter")])]), _vm._v(" "), (!_vm.$v.newForm.email.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The email is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.newForm.email.required && this.backendValidationEmailAddress.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationEmailAddress.errorMsg))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validateSubmission
    }
  }, [_vm._v("\n            Invite\n          ")]), _vm._v(" "), _c('sync-loader', {
    staticClass: "custom-modal-footer-items",
    attrs: {
      "loading": _vm.newModalLoading,
      "color": _vm.newModalColor,
      "size": _vm.newModalSize,
      "width": _vm.newModalWidth,
      "margin": _vm.newModalMargin
    }
  })], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "tableData"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Date\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Email\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("User Registration State\n                      ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25c62fab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/UserTeamView.vue
// module id = 2074
// module chunks = 1